var _rect, _rect2, _rect3, _rect4, _rect5, _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCuratedExperiences(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 56,
    viewBox: "0 0 55 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54.1558,
    height: 55.1587,
    rx: 7.25149,
    fill: "#C0D8D4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 13.0512,
    height: 5.02771,
    rx: 1.19707,
    transform: "matrix(-0.555186 0.831727 0.831727 0.555186 22.2866 20.5674)",
    fill: "url(#paint0_linear_6443_30364)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 13.0512,
    height: 5.02771,
    rx: 1.19707,
    transform: "matrix(-0.555186 0.831727 0.831727 0.555186 22.2866 20.5674)",
    fill: "black",
    fillOpacity: 0.1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 13.0512,
    height: 5.02771,
    rx: 1.19707,
    transform: "matrix(-0.997817 0.0660392 0.0660392 0.997817 41.418 16.7617)",
    fill: "url(#paint1_linear_6443_30364)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 13.0512,
    height: 5.02771,
    rx: 1.19707,
    transform: "matrix(-0.997817 0.0660392 0.0660392 0.997817 41.418 16.7617)",
    fill: "black",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.15232,
    cy: 9.15232,
    r: 9.15232,
    transform: "matrix(0 1 1 0 6.5293 25.2842)",
    fill: "url(#paint2_linear_6443_30364)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.15232,
    cy: 9.15232,
    r: 9.15232,
    transform: "matrix(0 1 1 0 6.5293 25.2842)",
    fill: "black",
    fillOpacity: 0.1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.78632,
    cy: 6.78632,
    r: 6.78632,
    transform: "matrix(0 1 1 0 20.3826 14.4092)",
    fill: "url(#paint3_linear_6443_30364)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.78632,
    cy: 6.78632,
    r: 6.78632,
    transform: "matrix(0 1 1 0 20.3826 14.4092)",
    fill: "black",
    fillOpacity: 0.1
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.45085,
    cy: 5.45085,
    r: 5.45085,
    transform: "matrix(0 1 1 0 38.1882 13.5186)",
    fill: "url(#paint4_linear_6443_30364)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.45085,
    cy: 5.45085,
    r: 5.45085,
    transform: "matrix(0 1 1 0 38.1882 13.5186)",
    fill: "black",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6443_30364",
    x1: 2.68146,
    y1: 1.40699e-8,
    x2: 5.52274,
    y2: 8.26319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6443_30364",
    x1: 2.68146,
    y1: 1.40699e-8,
    x2: 5.52274,
    y2: 8.26319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6443_30364",
    x1: 3.76081,
    y1: 5.1225e-8,
    x2: 20.4733,
    y2: 18.7239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6443_30364",
    x1: 2.78859,
    y1: 3.79826e-8,
    x2: 15.1807,
    y2: 13.8835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6443_30364",
    x1: 2.23982,
    y1: 3.0508e-8,
    x2: 12.1933,
    y2: 11.1514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuratedExperiences);
export default __webpack_public_path__ + "static/media/curatedExperiences.b5a96d0ae01a0ffd126a8b5afb9f4c7f.svg";
export { ForwardRef as ReactComponent };